<template>
  <div :class="['field-group', 'mb-l', displayMode ? 'display' : '']">
    <form-field
      :key="field.id"
      v-for="(field, i) in fields"
      :field-index="groupIndex + i"
      :field-type="field.type"
      :label="field.label"
      :hide-label="!labelAllFields && groupIndex !== 0"
      :external-label="field.externalLabel"
      :rounded="field.rounded"
      :circle="field.circle"
      :background="field.background"
      :color="field.color"
      :label-color="field.labelColor"
      :select-options="field.options"
      :select-placeholder="' '"
      :disabled="isDisabled(field)"
      :class="[i < fields.length - 1 ? 'mx-s' : '', field.css]"
      :locale = "locale"  
      @broadcast="updateFromField"
      v-model="fieldsData[field._prop]"
      @validate-field="emitValidHash"
      @remove-validation="removeValidHash"
      :err="validHash[field.label + groupIndex] === false"
      :dirty="!isDisabled(field) && dirtyFields"
      :err-msg="localize('this_fileld_required')"
      :req="field.required"
    ></form-field>
    <a
      v-if="!displayMode && count > 1"
      :class="[
        disabled ? 'disabled' : '',
        'copy-btn',
        'mx-m',
        groupIndex === 0 ? 'mt-xl' : ''
      ]"
      href="#p"
      @click.prevent="copyToAll"
      ><i class="fal fa-copy"></i
    ></a>
    <slot></slot>
    <!-- :value="field._prop ? toothData[field._prop] : null" -->
  </div>
</template>

<script>
/****
 * This component is a group of fields
 * connected to 1 tooth
 * IN:
 *  fields[], toothData{}, groupIndex(Num)
 * OUT:
 * {
 * toothNum,
 * field[prop],
 * ...
 * ...
 * }
 */
import FormField from "@/components/FormField.vue";

export default {
  props: {
    locale: {
      type: String,
      default: 'EN'
    },
    dirtyFields: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Array,
      required: true
    },
    toothData: {
      type: Object,
      default: null
    },
    count: Number,
    groupIndex: {
      type: Number,
      default: 0
    },
    displayMode: {
      type: Boolean,
      default: false
    },
    labelAllFields: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    value: Object
  },
  data() {
    return {
      fieldsData: {}
    };
  },
  mounted() {
    this.initFieldProps();
  },
  watch: {
    fieldsData: {
      deep: true,
      handler() {
        if (!this.displayMode) {
          this.$emit("input", this.fieldsData);
          this.$eventHub.emit("force-validate");
        }
      }
    },
    "toothData.num"() {
      this.fieldsData.num = this.toothData.num;
    },
    value: {
      deep: true,
      handler() {
        if (this.displayMode) {
          this.initFieldProps();
        }
      }
    }
  },
  components: {
    FormField
  },
  destroyed() {},
  methods: {
    isDisabled(field) {
      return (
        this.disabled ||
        this.displayMode ||
        field.disabled ||
        (field.requires && !this.fieldsData[field.requires])
      );
    },
    removeValidHash(id) {
      let prop = id + this.groupIndex;
      // console.log("remove from valid hash (fieldgroup) .> ", prop);
      if (!this.disabled) {
        this.$emit("remove-validation", prop);
      }
    },
    emitValidHash(id, valid) {
      let prop = id + this.groupIndex;
      if (!this.disabled) {
        this.$emit("update-valid-hash", prop, valid);
      }
    },
    initFieldProps() {
      let val = _.clone(this.value);
      // console.log("initFieldProps >> ", val);
      // console.log("toothData >> ", this.toothData);
      let fieldProps = {};
      // This will return an Object{} with the props to each
      // field as passed on from parent

      if (val) {
        fieldProps = Object.assign(val, fieldProps);
      } else {
        let propsObj = this.toothData || this.fields;
        // console.log("propsObj> ", propsObj);
        // console.log("this.fields> ", this.fields);
        fieldProps = Object.assign(
          {},
          ...this.fields.map(t => {
            return Object.assign(
              { [t._prop]: t.enumerable ? propsObj[t._prop] : null },
              {}
            );
          })
        );
      }
      if (this.toothData) {
        fieldProps = Object.assign(fieldProps, this.toothData);
      }

      // console.log("fieldProps >> ", fieldProps);
      this.fieldsData = fieldProps;
    },
    updateFromField(e) {
      console.log("UPDATE FROM FIELD> ", e);
    },
    copyToAll() {
      console.log('copyToAll: ', this.fieldsData);
      this.$emit("copy-to-all", this.fieldsData);
    },
    positive(val) {
      return !!this.fieldsData[val];
    }
  }
};
</script>

<style lang="stylus">
.field-group
  _flex(row, nowrap, flex-end, flex-start)
  // width 90%
  // &.display
  //   width 100%
  & > *
    flex 1
    &.mini
      max-width 60px
      flex none
      input
        text-align center
    &.longer
      flex 1.5
  .copy-btn
    align-self center
    font-size 20px
    flex none
    &.disabled
      pointer-events none
      opacity 0
    i
      transition color 0.2s ease-out
    &:hover
      i
        color blue_brand !important
</style>
